import { themes } from '../lib/themes'
import { isSavedThemeId } from '../lib/customThemes'
import { useTheme } from '../context/ThemeContext'

const ThemeSelect = () => {
  const { theme, setTheme, themes: builtInThemeIds, customThemes } = useTheme()

  const handleChange = (event) => {
    setTheme(event.target.value)
  }

  return (
    <div className="flex w-full min-w-0 items-center gap-3">
      <label htmlFor="site-theme" className="site-label shrink-0">
        Themes
      </label>
      <select
        id="site-theme"
        name="site-theme"
        value={isSavedThemeId(theme) ? theme : 'maya'}
        onChange={handleChange}
        className="site-frame site-theme-select flex h-10 min-w-[7.5rem] flex-1 cursor-pointer items-center px-3 text-xs font-medium uppercase tracking-[0.14em] text-text-primary transition-opacity hover:opacity-80"
        aria-label="Choose Maya color theme"
      >
        {customThemes.length ? (
          <optgroup label="Custom">
            {customThemes.map((entry) => (
              <option key={entry.id} value={entry.id}>
                {entry.label}
              </option>
            ))}
          </optgroup>
        ) : null}
        <optgroup label="Built-in">
          {builtInThemeIds.map((themeId) => (
            <option key={themeId} value={themeId}>
              {themes[themeId].label}
            </option>
          ))}
        </optgroup>
      </select>
    </div>
  )
}

export default ThemeSelect
